import ChartItems from "../components/charts/chartItems";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { db } from "../firebase";

const SingleChartPage = () => {
  const { id } = useParams();
  const [latestCharts, setLatestCharts] = useState();

  const docRef = db.collection("blogs/blog/Charts").doc(id);
  docRef
    .get()
    .then((doc) => {
      if (doc.exists) {
        setLatestCharts({ ...doc.data() });
      } else {
        console.log("No such document!");
      }
    })
    .catch((error) => {
      console.log("Error getting document:", error);
    });

  return (
    <div className="single-chart-page">
      {latestCharts && (
        <div className="container">
          <h1>{latestCharts.chartTitle}</h1>
          <h2 className="opacity">افضل {latestCharts.chartLength}</h2>
          <ChartItems loop={latestCharts.chartItems} />
        </div>
      )}
    </div>
  );
};

export default SingleChartPage;
